export default {"src":"/_next/static/media/shield-lock-2.25325467.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};